import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { MDBCol, MDBRow } from 'mdbreact';
import Page from 'components/PageStructure';
import DateField from 'components/FormGroup/DateField';

import Overlay from 'components/Informations/Overlay';
import Toast from 'components/Informations/Toast';

import FilledButton from 'components/Buttons/FilledButton';
import UnfilledButton from 'components/Buttons/UnfilledButton';

import useFetch from 'hooks/useFetch';
import { isSameMonth } from 'utils/moment';
import { FormatCurrency } from 'utils/core';
import endpoints from 'services/endpoints';

import StatusCards from './InternalComponents/StatusCards';
import RefundsTable from './InternalComponents/RefundsTable';

import * as S from './styles';

const { getRefundsInfoToEmployee, deleteRequestedRefund } = endpoints;

export default function EmployeeRefunds({ history, user }) {
  const { id_funcionario: userID } = user;
  const [month, setMonth] = useState(new Date());
  const [data, setData] = useState();

  const [totalPrice, setTotalPrice] = useState();
  const [totalPriceApproved, setTotalPriceApproved] = useState();
  const [totalPriceRefused, setTotalPriceRefused] = useState();

  const [idToRemove, setIdToRemove] = useState();

  const [overlayVisibility, setOverlayVisibility] = useState(false);
  const [overlayType, setOverlayType] = useState('');
  const [overlayAction, setOverlayAction] = useState(() => {});

  const [toastType, setToastType] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastClose, setToastClose] = useState(2000);
  const [toastVisibility, setToastVisibility] = useState(false);

  const [reloadData, setRealoadData] = useState(false);
  const [myRefunds] = useFetch(
    `${getRefundsInfoToEmployee}/${userID}`,
    reloadData,
  );

  const renderOverlay = type => {
    switch (type) {
      case 'delete':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="warning"
            text={[
              'Você está ',
              <span>exluindo esta solicitação</span>,
              ' tem certeza que deseja prosseguir com essa solicitação',
            ]}
          >
            <UnfilledButton
              text="Sim, continuar"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
                overlayAction(idToRemove);
              }}
            />
            <FilledButton
              text="Não"
              buttonClass="warn"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
          </Overlay>
        );

      case 'returning':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="warning"
            text={[
              'Você está ',
              <span>voltando para a tela anterior</span>,
              ' e esta ação irá ',
              <span>descartar</span>,
              ' as alterações que não foram salvas. Deseja continuar?',
            ]}
          >
            <UnfilledButton
              text="Sim, continuar"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
            <FilledButton
              text="Não, permanecer"
              buttonClass="warn"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
          </Overlay>
        );

      case 'confirm':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="success"
            text={[
              'Você está ',
              <span>solicitando reembolso</span>,
              ' de despesas gastas neste projeto. Deseja continuar?',
            ]}
          >
            <UnfilledButton
              text="Sim"
              handleClick={() => {
                overlayAction();
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
            <FilledButton
              text="Não"
              buttonClass="confirm"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
          </Overlay>
        );

      default:
        return '';
    }
  };

  const renderToast = (type, message, closeTime) => {
    const condition = closeTime !== undefined ? closeTime : toastClose;

    setToastVisibility(true);
    setToastMessage(message);
    setToastType(type);
    setToastClose(condition);

    setTimeout(() => {
      setToastVisibility(false);
      setToastMessage('');
      setToastType('');
    }, condition + 1500);
  };

  useEffect(() => {
    (async () => {
      const response = await myRefunds;
      const date = await month;

      const filteredData = response.filter(item =>
        isSameMonth(item.date, date),
      );

      const ApprovedPayment = filteredData.filter(
        item => item.id_aprovacao_gestor === 2,
      );
      const refusedRequest = filteredData.filter(
        item => item.id_aprovacao_gestor === 3,
      );

      const paymentRequested = _.sumBy(
        filteredData.map(item => ({ totalValue: item.valor_total })),
        'totalValue',
      );

      const paymentAuthorized = _.sumBy(
        ApprovedPayment.map(item => ({ totalValue: item.valor_total })),
        'totalValue',
      );

      const refusedAuthorization = _.sumBy(
        refusedRequest.map(item => ({ totalValue: item.valor_total })),
        'totalValue',
      );
      const orderedData = _.orderBy(filteredData, ['date'], ['asc']);

      setData(orderedData);
      setTotalPrice(paymentRequested);
      setTotalPriceApproved(paymentAuthorized);
      setTotalPriceRefused(refusedAuthorization);
    })();

    // const realizedPayment = filteredData.filter(item => item.id_aprovacao_pagamento === 2);
    // const paymentOk = _.sumBy(realizedPayment
    //  .map(item => ({ totalValue: item.valor_total })), 'totalValue');
    // const refusedPayment = filteredData.filter(item => item.id_aprovacao_pagamento === 3);
    // const requestPayRefused = _.sumBy(refusedPayment
    //  .map(item => ({ totalValue: item.valor_total })), 'totalValue');

    // setTotalRealizedPayment(paymentOk);
    // SetTotalRefusededPayment(requestPayRefused);
  }, [month, myRefunds]);

  const paymentRequested = {
    main: FormatCurrency(totalPrice),
  };
  const paymentAuthorized = {
    main: FormatCurrency(totalPriceApproved),
    pending: FormatCurrency(
      totalPrice - (totalPriceApproved + totalPriceRefused),
    ),
    refused: FormatCurrency(totalPriceRefused),
  };

  // const paymentRealized = {
  //   main: FormatCurrency(totalRealizedPayment),
  //   pending: FormatCurrency(
  //     (totalPriceApproved) - (totalRealizedPayment + totalRefusededPayment),
  //   ),
  //   refused: FormatCurrency(totalRefusededPayment),
  // };

  return (
    <>
      {overlayVisibility && renderOverlay(overlayType, overlayAction)}

      {toastVisibility && (
        <Toast
          type={toastType}
          message={toastMessage}
          autoClose={toastClose}
          hideProgress
        />
      )}
      <Page
        title="Meus reembolsos"
        subtitle="Visualize o andamento das suas solicitações de reembolso"
        previousPage
        pageAction={() =>
          history.push({
            pathname: '/auth/appointments',
            // eslint-disable-next-line react/prop-types
            state: history.location.state,
          })
        }
      >
        <MDBRow>
          <MDBCol lg="4" md="12">
            <StatusCards title="Total solicitado" price={paymentRequested} />
          </MDBCol>
          <MDBCol lg="4" md="12">
            <StatusCards title="Total aprovado" price={paymentAuthorized} />
          </MDBCol>
          {/* <MDBCol lg="4" md="12">
            <StatusCards title="Total pago" price={paymentRealized} />
          </MDBCol> */}
        </MDBRow>

        <MDBRow>
          <MDBCol>
            <S.SelectsWrap>
              <DateField
                onlyMonth
                selectedValue={month}
                startDate={new Date()}
                handleChange={e => setMonth(e)}
                name="filterDate"
                id="filterDate"
                className="w-70 date-to-approve"
                labelText="Selecione um mês"
              />
            </S.SelectsWrap>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <RefundsTable
              data={data}
              userID={userID}
              deleteEndPoint={deleteRequestedRefund}
              setRealoadData={setRealoadData}
              setOverlayVisibility={setOverlayVisibility}
              setOverlayType={setOverlayType}
              setOverlayAction={setOverlayAction}
              setIdToRemove={setIdToRemove}
              renderToast={renderToast}
            />
          </MDBCol>
        </MDBRow>
      </Page>
    </>
  );
}

EmployeeRefunds.defaultProps = {
  history: {},
  user: {},
};

EmployeeRefunds.propTypes = {
  history: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  ),
  user: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
};
